import Button from './_button.js'
import Image from './_image.js'
import FlexPane from './_flex-pane.js'
import Popup from './_popup.js'
import AbsolutePane from './_absolute-pane.js'
import Hideable from './_hideable.js'

export default {
  name: 'BetslipSettings',
  values: {
    popupToggleButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            alignItems: 'center',
            minWidth: '40px',
            minHeight: '40px',
          },
        },
      },
    },
    popupToggleButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'settings',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    popupToggleButtonIconContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          justifyContent: 'center',
        },
      },
    },
    popup: {
      configSet: Popup,
      configValues: {
        container: {
          style: {
            width: '294px',
            bottom: '40px',
            left: '4px',
          },
        },
        content: {
          style: {
            base: {
              flexDirection: 'column',
            },
          },
        },
      },
    },
    highlightedSettingsIndicator: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          bottom: '10px',
          left: '22px',
          width: '8px',
          height: '8px',
          borderRadius: '8px',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: 'white',
        },
      },
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
